export const RESET_STATE = 'RESET_STATE' as const;
export const REQUEST_CREATE_SURFACE = 'REQUEST_CREATE_SURFACE' as const;
export const REQUEST_CREATE_SURFACE_SUCCESS =
  'REQUEST_CREATE_SURFACE_SUCCESS' as const;
export const REQUEST_CREATE_SURFACE_FAILED =
  'REQUEST_CREATE_SURFACE_FAILED' as const;
export const SELECT_HOUSE = 'SELECT_HOUSE' as const;
